// Whether va-header-navigation shows its navigation in the bar (desktop).
// Below that width the navigation moves into its Menu button (mobile).
export const headerShowsNavInBar = header => {
  const list = header?.shadowRoot?.querySelector('.header-nav__list');
  return !!list && getComputedStyle(list).display !== 'none';
};
